import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import useUserContext from 'Context/UserContext';
import AssumptionsAdmin from './AssumptionsAdmin';

const AssumptionsAdminPicker = (props) => {
  const { userResource } = useUserContext();

  return pick(userResource, {
    [fr.relationships.facetPlanAssumptions.name]: <AssumptionsAdmin {...props} />,
  }, null);
};

export default AssumptionsAdminPicker;
